import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DynamicForm from '../dynamicForm/DynamicForm';
import { ActionButtons } from '../others/ActionButtons';
import { validateAndEnsureArray } from '../../utils/jsonValidator';
import { useManageFlows } from '../../screens/flows/hooks/useManageFlows';

export const ManageFuntions = ({ open, data = [], typeComponent, setOpen, addFunction, deleteFunction }) => {
    const [schema, setSchema] = useState([]);
    const [idxEdit, setidxEdit] = useState(null);
    const [{ listFunctionsSchema }] = useManageFlows();
    const [contentJson, setContentJson] = useState({
        name: '',
        params: {}
    });

    const getJsonSchema = (val) => {
        const schemas = listFunctionsSchema.find(e => e.name === val);
        return validateAndEnsureArray(schemas?.json_schema);
    }

    const handleSelectFuntion = ({ name, value }) => {
        setContentJson({ ...contentJson, [name]: value });
        setSchema(getJsonSchema(value));
    }

    const handleEdit = (obj, idx) => {
        setOpen(true);
        setidxEdit(idx);
        setSchema(getJsonSchema(obj.name));
        setContentJson(obj);
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setContentJson(prevState => ({
            ...prevState,
            params: {
                ...prevState.params,
                [name]: value
            }
        }));
    }

    const handleCancel = () => {
        setContentJson({
            name: '',
            params: {}
        });
        setOpen(false);
        setidxEdit(null);
        setSchema([]);
    }

    const handleAdd = () => {
        addFunction(contentJson, idxEdit);
        handleCancel();
    }

    const formatText = (obj) => {
        if (obj?.params && typeof obj.params === 'object' && obj.params !== null) {
            return <Typography>
                {
                    Object.entries(obj.params)
                        .map(([key, value]) => `${key}: ${value}`)
                        .join(', ')
                }
            </Typography>
        }
        return null;
    }

    return (
        <>
            <TableContainer
                style={{ height: '35vh', overflow: 'auto', borderBottom: 'solid 1px' }}
            >
                <Table
                    aria-labelledby='tableTitle'
                    size='small'
                    stickyHeader
                >
                    <TableHead>
                        <TableRow sx={{ px: 2 }}>
                            <TableCell
                                align='center'
                                style={{ width: '60px' }}
                            >
                                Acciones
                            </TableCell>
                            <TableCell
                                padding='normal'
                                align='center'
                                key={`tc-name`}
                            >
                                name
                            </TableCell>
                            <TableCell
                                padding='normal'
                                align='center'
                                key={`tc-param`}
                            >
                                parametros
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {
                            data.map((item, idx) => (
                                <TableRow
                                    tabIndex={idx}
                                    key={idx}
                                >
                                    <TableCell
                                        align='center'
                                        sx={{ display: 'flex' }}
                                    >
                                        <Tooltip title={'Editar funcion/es'}>
                                            <IconButton
                                                aria-label="close"
                                                onClick={() => handleEdit(item, idx)}
                                                sx={{ color: 'gray' }}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={'Eliminar'}>
                                            <IconButton
                                                aria-label="close"
                                                onClick={() => deleteFunction(idx)}
                                                sx={{ color: 'red' }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell
                                        padding='normal'
                                        align='center'
                                    >
                                        {item.name}
                                    </TableCell>
                                    <TableCell
                                        padding='normal'
                                        align='center'
                                    >
                                        {formatText(item)}
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog
                open={open}
                fullWidth
                maxWidth='sm'
            >
                <DialogTitle>
                    <Typography variant='h5' component='h5'>
                        Función
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                        <Grid container spacing={2} sx={{ marginBottom: 1 }}>
                            <Grid size={{ xs: 12, sm:12 }}>
                                <TextField
                                    id={'IdSelectName'}
                                    name={'name'}
                                    select
                                    fullWidth
                                    label='Función'
                                    variant="outlined"
                                    value={contentJson?.name || ''}
                                    onChange={(e) => handleSelectFuntion(e.target)}
                                    size="small"
                                    defaultValue="none"
                                    disabled={idxEdit !== null}
                                >
                                    {listFunctionsSchema
                                        .filter((e) => e.type === typeComponent)
                                        .map((item, idx) => (
                                            <MenuItem key={idx} value={item.name} >
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                </TextField>
                            </Grid>
                        </Grid>
                        <DynamicForm
                            values={contentJson.params}
                            scheme={schema}
                            errorInputs={{}}
                            onChange={onChange}
                        />
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <ActionButtons
                            onCancel={handleCancel}
                            onSubmit={handleAdd}
                        />
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
}
